import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('employee', 'employees');

const customActions = {
  async LOAD_employees({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('employees')
      .query({ $filter: 'IsDeleted eq false', $orderby: 'firstName' });
    commit('SET_employees', data);
  },
  async LOAD_last_employee({ rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('employees')
      .query({ $filter: 'IsDeleted eq false', $orderby: 'employeeCode DESC', $top: 1 });
    return data;
  },
  async LOAD_employee({ commit, rootGetters }, id) {
    console.log('custom load');
    const i = odata.parseId(id);
    const data = await odata.o(rootGetters)
      .get(`employees(${i})`)
      .query({ $expand: 'RateSchedules' });
    data.rateSchedules = data.rateSchedules.map((r) => {
      const result = { ...r };
      result.startDate = r.startDate.substring(0, 10);
      result.endDate = r.endDate.substring(0, 10);
      return result;
    });
    commit('SET_employee', data);
  },
};

export default { ...actions, ...customActions };
